export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/c149c2995e67c98d8198109bf15793c7.svg";